import 'reflect-metadata';

import IPackageConfiguration from '@orcha/types/package';
import { injectable } from 'inversify';
import ApiClient from './api-client';
import { IPackageService } from './interfaces';

@injectable()
class PackageService implements IPackageService {
  private apiClient: ApiClient;

  public constructor() {
    this.apiClient = new ApiClient(process.env.PACKAGE_API_BASE_URL ?? '');
  }

  public async getPackageByDomainName(
    domainName: string
  ): Promise<IPackageConfiguration | undefined> {
    const response = await this.apiClient.get<IPackageConfigurationDataWrapper>(
      `packages/${domainName}`
    );

    return response?.data?.package;
  }
}

interface IPackageConfigurationDataWrapper {
  data?: { package: IPackageConfiguration };
  status: string;
}

export default PackageService;
